import { render } from "./UserPicker.vue?vue&type=template&id=1e23693c"
import script from "./UserPicker.vue?vue&type=script&lang=ts"
export * from "./UserPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script